module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-col', {
    staticClass: "toolbar uptool",
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "请输入设备ID",
      "prefix-icon": "el-icon-search",
      "size": "small"
    },
    model: {
      value: (_vm.SearchDid),
      callback: function($$v) {
        _vm.SearchDid = $$v
      },
      expression: "SearchDid"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "small",
      "size": "small"
    },
    on: {
      "click": _vm.SelectionQuery
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('el-form-item', [_vm._v("\n                |\n            ")]), _vm._v(" "), _c('el-form-item', [_c('el-dropdown', {
    attrs: {
      "trigger": "click",
      "type": "primary"
    },
    on: {
      "command": _vm.handleSelectByOnlineStatus
    }
  }, [_c('el-button', {
    staticClass: "el-dropdown-link",
    attrs: {
      "type": "small"
    }
  }, [_vm._v("\n                        筛选 - [在线状态]\n                        "), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "online"
    }
  }, [_vm._v("在线")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "command": "offline"
    }
  }, [_vm._v("下线")])], 1)], 1)], 1), _vm._v(" "), (_vm.SearchOnlineStatus != '') ? _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": "点击取消筛选",
      "placement": "top",
      "open-delay": "1000"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger",
      "size": "mini",
      "icon": "el-icon-error",
      "round": ""
    },
    on: {
      "click": _vm.Refresh
    }
  }, [_vm._v("\n                        " + _vm._s((_vm.SearchOnlineStatus == 'offline' ? '下线' : (_vm.SearchOnlineStatus ==
    'online' ? '在线' : '未知')) + _vm.total + '台') + "\n                    ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "size": "small"
    },
    on: {
      "click": _vm.Refresh
    }
  }, [_vm._v("刷新")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listloading),
      expression: "listloading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.List
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "width": "50",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(scope.$index + 1) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "device_name",
      "label": "设备ID",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "device_name",
      "label": "型号",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(_vm.getDeviceVersionName(scope.row.product_code, scope.row.edition_code)) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "first_time",
      "label": "首次上线时间",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "last_time",
      "label": "末次上线时间",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "online_count",
      "label": "上线总次数",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "online_status",
      "label": "在线状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.online_status == 'online') ? _c('p', [_c('i', {
          staticClass: "el-icon-upload",
          staticStyle: {
            "color": "#11b95c"
          }
        }), _vm._v(" 在线\n                ")]) : _vm._e(), _vm._v(" "), (scope.row.online_status == 'offline') ? _c('p', [_c('i', {
          staticClass: "el-icon-warning",
          staticStyle: {
            "color": "#ff4949"
          }
        }), _vm._v(" 下线\n                ")]) : _vm._e(), _vm._v(" "), (scope.row.online_status != 'online' && scope.row.online_status != 'offline') ? _c('p', [_c('i', {
          staticClass: "el-icon-question",
          staticStyle: {
            "color": "#f7ba2a"
          }
        }), _vm._v(" 未知\n                ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), (_vm.Limits.device_data_view) ? _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.List[scope.$index].edition != '机构版') ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.gotoDetails(scope.row, scope.$index, scope.column)
            }
          }
        }, [_vm._v("\n                    查看\n                ")]) : _vm._e()]
      }
    }])
  }) : _vm._e()], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "page-size": _vm.Pagesize,
      "current-page": _vm.Curpage,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handlePageChanged
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "运行状态",
      "visible": _vm.detailsVisiable,
      "fullscreen": true,
      "before-close": _vm.closeDeviceStatusDetailDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.detailsVisiable = $event
      }
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-tag', [_vm._v(_vm._s(_vm.curDid))]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "success"
    }
  }, [(_vm.dev_software_version_r != _vm.dev_software_version_f) ? _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("r:v" + _vm._s(_vm.dev_software_version_r) + " / f:v" + _vm._s(_vm.dev_software_version_f))]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-warning",
    staticStyle: {
      "color": "#ff4949"
    }
  })]) : _vm._e(), _vm._v("\n                     固件版本：v" + _vm._s(_vm.dev_software_version_r) + "\n                ")], 1), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v(_vm._s(_vm.dev_edition))]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("最近一次上线时间：" + _vm._s(_vm.last_online_time))]), _vm._v(" "), _c('el-tag', [_vm._v(" 发货地址：" + _vm._s(("" + _vm.shipping_prov + _vm.shipping_city + _vm.shipping_dist + _vm.shipping_addr)))])], 1)], 1), _vm._v(" "), _c('el-tabs', {
    on: {
      "tab-click": _vm.clickTab
    },
    model: {
      value: (_vm.tabActiveName),
      callback: function($$v) {
        _vm.tabActiveName = $$v
      },
      expression: "tabActiveName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "运行状态",
      "name": "1"
    }
  }, [_c('el-row', {
    staticStyle: {
      "font-size": "10px",
      "font-weight": "bold",
      "color": "#808c939d"
    }
  }, [_vm._v(" " + _vm._s(_vm.yxUpdateTime))]), _vm._v(" "), _vm._l((_vm.yxTitles), function(r, rindex) {
    return _c('el-row', {
      attrs: {
        "gutter": 0
      }
    }, _vm._l((r), function(c, cindex) {
      return _c('el-col', {
        key: c,
        attrs: {
          "span": 6,
          "offset": 0
        }
      }, [_c('el-card', [_c('div', {
        attrs: {
          "slot": ""
        },
        slot: "default"
      }, [_c('div', {
        staticClass: "title-text"
      }, [_vm._v(_vm._s(c))]), _vm._v(" "), (_vm.yxValues[rindex][cindex] != null && _vm.yxValues[rindex][cindex].length > 6) ? _c('marquee', {
        staticClass: "marquee-value-text"
      }, [_vm._v("\n                                    " + _vm._s(_vm.yxValues[rindex][cindex]) + "\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.yxValues[rindex][cindex] != null && _vm.yxValues[rindex][cindex].length <= 6) ? _c('div', {
        class: {
          'null-value-text': _vm.yxValues[rindex][cindex] == '等待上报', 'value-text': _vm.yxValues[rindex][cindex] != '等待上报'
        }
      }, [_vm._v("\n                                    " + _vm._s(_vm.yxValues[rindex][cindex]) + "\n                                ")]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "unit-text"
      }, [_vm._v(_vm._s(_vm.yxUnits[rindex][cindex]))])], 1)])], 1)
    }))
  })], 2), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "行为统计",
      "name": "2"
    }
  }, [_c('el-row', {
    staticStyle: {
      "font-size": "10px",
      "font-weight": "bold",
      "color": "#808c939d"
    }
  }, [_vm._v(" " + _vm._s(_vm.xwUpdateTime))]), _vm._v(" "), _vm._l((_vm.xwTitles), function(r, rindex) {
    return _c('el-row', {
      attrs: {
        "gutter": 0
      }
    }, _vm._l((r), function(c, cindex) {
      return _c('el-col', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (c.show),
          expression: "c.show"
        }],
        key: c.name,
        attrs: {
          "span": 6,
          "offset": 0
        }
      }, [_c('el-card', [_c('div', {
        attrs: {
          "slot": ""
        },
        slot: "default"
      }, [_c('div', {
        staticClass: "title-text"
      }, [_vm._v(_vm._s(c.name))]), _vm._v(" "), _c('div', {
        class: {
          'null-value-text': _vm.xwValues[rindex][cindex] == '等待上报', 'value-text': _vm.xwValues[rindex][cindex] != '等待上报'
        }
      }, [_vm._v("\n                                    " + _vm._s(_vm.xwValues[rindex][cindex]) + "\n                                ")]), _vm._v(" "), _c('div', {
        staticClass: "unit-text"
      }, [_vm._v(_vm._s(_vm.xwUnits[rindex][cindex]))])])])], 1)
    }))
  })], 2), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "家庭康复",
      "name": "3"
    }
  }, [_c('el-row', {
    staticStyle: {
      "font-size": "10px",
      "font-weight": "bold",
      "color": "#808c939d"
    }
  }, [_vm._v(" " + _vm._s(_vm.xwUpdateTime))]), _vm._v(" "), _vm._l((_vm.kfTitles), function(r, rindex) {
    return _c('el-row', {
      attrs: {
        "gutter": 0
      }
    }, _vm._l((r), function(c, cindex) {
      return _c('el-col', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (c.show),
          expression: "c.show"
        }],
        key: c.name,
        attrs: {
          "span": 6,
          "offset": 0
        }
      }, [_c('el-card', [_c('div', [_c('div', {
        staticClass: "title-text"
      }, [_vm._v(_vm._s(c.name))]), _vm._v(" "), (cindex == 0 && (_vm.dev_edition == _vm.XZ_SPORT || _vm.dev_edition == _vm.XZ_SPORT_LITE || _vm.dev_edition == _vm.XZ_WHEELCHAIR || _vm.dev_edition == _vm.XZ_HOME) && _vm.kfValues[rindex][cindex] > 0) ? _c('el-button', {
        staticStyle: {
          "display": "inline-block",
          "float": "right"
        },
        attrs: {
          "type": "text"
        },
        on: {
          "click": function($event) {
            _vm.handlePeriodAnalyze(_vm.curDid)
          }
        }
      }, [_vm._v("\n                                    前3月时段分布\n                                ")]) : _vm._e(), _vm._v(" "), _c('div', {
        class: {
          'null-value-text': _vm.kfValues[rindex][cindex] == '等待上报', 'value-text': _vm.kfValues[rindex][cindex] != '等待上报'
        }
      }, [_vm._v("\n                                    " + _vm._s(_vm.kfValues[rindex][cindex]) + "\n                                ")]), _vm._v(" "), _c('div', {
        staticClass: "unit-text"
      }, [_vm._v(_vm._s(_vm.kfUnits[rindex][cindex]))])], 1)])], 1)
    }))
  })], 2), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "错误日志",
      "name": "4"
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.deviceErrorLogList
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "#",
      "width": "50",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                            " + _vm._s(scope.$index + 1) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "日志内容"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "received_time",
      "label": "接收时间",
      "width": "180",
      "align": "center"
    }
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "page-size": _vm.deviceErrorLogPageSize,
      "current-page": _vm.deviceErrorLogCurPage,
      "total": _vm.deviceErrorLogTotal
    },
    on: {
      "current-change": _vm.handleErrorLogPageChanged
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "前3月时段分布",
      "visible": _vm.periodDetailsVisiable,
      "width": "90%",
      "top": "0%",
      "before-close": _vm.closePeriodDetailDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.periodDetailsVisiable = $event
      }
    }
  }, [_c('div', {
    staticClass: "box-charts",
    attrs: {
      "id": "DetailBox"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f476d32"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/DeviceStatusManagement.vue
// module id = 1290
// module chunks = 1